// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-container{max-width:100%!important}.ag-theme-material .ag-icon-checkbox-checked{color:#2e3444!important}.v-navigation-drawer__content::-webkit-scrollbar{width:8px}.v-navigation-drawer__content::-webkit-scrollbar-track{background:transparent}.v-navigation-drawer__content::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.412);border:1px solid #a5a5a5;border-radius:15px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
